export default [
    {
        id: '0',
        icon: 'iconfont icon-xiaolian',
        name: '首页',
        url: '/home'
    },
    // {
    //     id: '1',
    //     icon: 'iconfont icon-menu',
    //     name: '基础信息',
    // },
    {
        id: '2',
        icon: 'iconfont icon-menu',
        name: '订单管理',
        children: [
            {
                id: '20',
                name: '打印订单',
                url: '/printOrderList',
                /*children : [
                    {
                        id: '201',
                        name: '测试多级',
                        children: [
                            {
                                id: '21111',
                                name: '打印订单',
                                url: '/printOrderList',
                            }
                        ],
                    }
                ]*/
            },
            {
                id: '21',
                name: '商城订单',
                url: '/mallOrderList'
            },
            {
                id: '22',
                name: '设计订单',
                url: '/designOrderList'
            },
            {
                id: '23',
                name: '模型订单',
                url: '/modelOrderList'
            },
            {
                id: '24',
                name: '服务订单',
                url: '/severOrderList'
            },
            // {
            //     id: '25',
            //     name: '软件订单',
            //     url: '/softwareOrderList'
            // },
        ]
    },
    {
        id: '3',
        icon: 'iconfont icon-menu',
        name: '审核管理',
        children: [
            {
                id: '30',
                name: '入驻审核',
                children: [
                    {
                        id: '300',
                        name: '设计师入驻',
                        url: '/designerEnter'
                    },
                    {
                        id: '301',
                        name: '服务商入驻',
                        url: '/facilitatorEnter'
                    },
                    {
                        id: '302',
                        name: '商家入驻',
                        url: '/merchantEnter'
                    }
                ]
            },
            {
                id: '31',
                name: '打印审核',
                children: [
                    {
                        id: '310',
                        name: '材料审核',
                        url: '/materialsAudit'
                    },
                    {
                        id: '311',
                        name: '服务审核',
                        url: '/serverAudit'
                    },
                    {
                        id: '312',
                        name: '成品审核',
                        url: '/productAudit'
                    }
                ]
            },
            {
                id: '32',
                name: '设计审核',
                children: [
                    {
                        id: '320',
                        name: '需求审核',
                        url: '/demandAudit'
                    },
                    {
                        id: '321',
                        name: '模型审核',
                        url: '/modelAudit'
                    },
                    {
                        id: '322',
                        name: '成果审核',
                        url: '/worksAudit'
                    },
                    {
                        id: '323',
                        name: '平面设计审核',
                        url: '/designAudit'
                    },
                ]
            },
            {
                id: '33',
                name: '商品审核',
                children: [
                    {
                        id: '330',
                        name: '商品审核',
                        url: '/goodsAudit'
                    },
                ]
            },
            {
                id: '34',
                name: '圈子管理',
                children: [
                    {
                        id: '340',
                        name: '创建圈子',
                        url: '/circleManager'
                    },
                    {
                        id: '341',
                        name: '圈子审核',
                        url: '/circleAudit'
                    },
                ]
            }
        ]
    },
    {
        id: '4',
        icon: 'iconfont icon-menu',
        name: '评价管理',
        children: [
            {
                id: '40',
                name: '评价管理',
                url: '/evaluationManagement'
            }
        ]
    },
    {
        id: '5',
        icon: 'iconfont icon-menu',
        name: '投诉管理',
        children: [
            {
                id: '50',
                name: '投诉管理',
                url: '/complaintManagement'
            },
        ]
    },
    {
        id: '6',
        icon: 'iconfont icon-menu',
        name: '店铺管理',
        children:[
            {
                id: '60',
                name: '服务商管理',
                url:'/shopProviders',
            },
            {
                id: '61',
                name: '商家管理',
                url:'/shopSettled',
            },
            {
                id: '62',
                name: '设计师管理',
                url:'/designerManage',
            },
            {
                id: '63',
                name: '佣金设置',
                url:'/commissionSet',
            }
        ]
    },
    {
        id: '7',
        icon: 'iconfont icon-menu',
        name: '应用管理'
    },
    {
        id: '8',
        icon: 'iconfont icon-menu',
        name: '小程序管理',
        children:[
            {
                id:'80',
                name:'打印小程序',
                children:[
                    {
                        id: '800',
                        name: '订单管理',
                        url: '/appletOrder'
                    },
                    {
                        id: '801',
                        name: '开票管理',
                        url: '/appletInvoice'
                    },
                    {
                        id: '802',
                        name: '行业案例',
                        url: '/appletCase'
                    },
                    {
                        id: '803',
                        name: '产品说明',
                        url: '/appletExplain'
                    },
                    {
                        id: '804',
                        name: '关于我们',
                        url: '/appletAbout'
                    },
                    {
                        id: '805',
                        name: '留言管理',
                        url: '/appletMessage'
                    },
                ]
            },
            {
                id:'81',
                name:'砂芯小程序',
                children:[
                    {
                        id: '810',
                        name: '订单管理',
                        url: '/appletOrderSx'
                    },
                    {
                        id: '811',
                        name: '开票管理',
                        url: '/appletInvoiceSx'
                    },
                    {
                        id: '812',
                        name: '行业案例',
                        url: '/appletCaseSx'
                    },
                    {
                        id: '813',
                        name: '产品说明',
                        url: '/appletExplainSx'
                    },
                    {
                        id: '814',
                        name: '关于我们',
                        url: '/appletAboutSx'
                    },
                    {
                        id: '815',
                        name: '留言管理',
                        url: '/appletMessageSx'
                    },
                ]
            }
        ]
    },
    {
        id: '9',
        icon: 'iconfont icon-menu',
        name: '活动管理',
        children:[
            {
                id: '90',
                name: '活动管理',
                url: '/activityManagement'
            },
            {
                id: '91',
                name: '报名管理',
                url: '/signManagement'
            },
            {
                id: '92',
                name: '作品管理',
                url: '/worksManagement'
            },
            {
                id: '93',
                name: '评委管理',
                url: '/judgesManagement'
            },
            {
                id: '94',
                name: '领导管理',
                url: '/leadershipManagement'
            },
            {
                id: '95',
                name: '评委库',
                url: '/judgesLibraryList'
            },
            {
                id: '96',
                name: '领导库',
                url: '/leadershipLibraryList'
            },

        ]
    },
    {
        id: '10',
        icon: 'iconfont icon-menu',
        name: '设计师等级管理',
        children:[
            {
                id: '97',
                name: '设计师等级管理',
                url:'/shopProviders',
            }
        ]
    },
    // {
    //     id: '10',
    //     icon: 'iconfont icon-menu',
    //     name: '系统设置',
    //     children:[
    //         {
    //             id: '100',
    //             name: '用户管理',
    //             children: [
    //                 {
    //                     id: '1000',
    //                     name: '个人用户',
    //                     url: '/userPersonal'
    //                 },
    //                 {
    //                     id: '1001',
    //                     name: '企业用户',
    //                     url: '/userEnterprise'
    //                 },
    //                 {
    //                     id: '1002',
    //                     name: '成员用户',
    //                     url: '/userStaff'
    //                 }
    //             ]
    //         }
    //     ]
    // }
]



// WEBPACK FOOTER //
// ./src/utils/navList.js